import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import TooltipWrapper from 'components/Tooltip';
import {ObjectPermissions} from 'types/permissions';

export type TeamMemberPermissions = Partial<
    ObjectPermissions<
        'employeeRights' | 'groups' | 'notifications' | 'overview'
    >
>;

type NavigationTabsTeamMemberProps = NavigationTabsPropsHelper<
    {
        mid: string;
    } & TeamMemberPermissions
>;

const NavigationTabsTeamMember: FC<NavigationTabsTeamMemberProps> = ({
    className,
    employeeRights,
    groups,
    mid,
    notifications,
    overview,
    selection,
}) => {
    const {t} = useTranslation('Navigation.NavigationTabs');

    return (
        <BaseNavigationTabs className={className} selection={selection}>
            {overview && (
                <TooltipWrapper message={t(overview.failureReason)}>
                    <BaseNavigationTabsButton
                        disabled={!overview.allowed}
                        href={window.Urls.employee_item_view(mid)}
                        label={t('teamMember.overview')}
                        name="overview"
                    />
                </TooltipWrapper>
            )}
            {employeeRights && (
                <TooltipWrapper message={t(employeeRights.failureReason)}>
                    <BaseNavigationTabsButton
                        disabled={!employeeRights.allowed}
                        href={window.Urls.member_rights_view(mid)}
                        label={t('teamMember.employeeRights')}
                        name="employeeRights"
                    />
                </TooltipWrapper>
            )}
            {notifications && (
                <TooltipWrapper message={t(notifications.failureReason)}>
                    <BaseNavigationTabsButton
                        disabled={!notifications.allowed}
                        href={window.Urls.notifications_employee_view(mid)}
                        label={t('teamMember.notifications')}
                        name="notifications"
                    />
                </TooltipWrapper>
            )}
            {groups && (
                <TooltipWrapper message={t(groups.failureReason)}>
                    <BaseNavigationTabsButton
                        disabled={!groups.allowed}
                        href={window.Urls.groups_view(mid)}
                        label={t('teamMember.groups')}
                        name="groups"
                    />
                </TooltipWrapper>
            )}
        </BaseNavigationTabs>
    );
};

export default NavigationTabsTeamMember;
